import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { PatientImportService } from '../service/patient-import.service';

@Injectable({
    providedIn: 'root'
})
export class PatientImportValidators
{
    constructor(private patientImportService: PatientImportService) { }

    public validatePatientImportNameUnique(control: UntypedFormControl, initialName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialName !== control.value)
            {
                this.patientImportService.existsPatientImportBatchName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
